import * as requests from "../../coraWebComponents/utils/requests";
import urls from "../../constants/Urls";

// CONSTANTS
const _lastYearDate = new Date(new Date().getFullYear() - 1, 0, 1);
const _currYearDate = new Date(new Date().getFullYear(), 0, 1);

// HANDLE DATA
const handleGridData = (NAZOV, chartDataCurrYear, chartDataLastYear) => {
  return [
    {
      ID: 0,
      NAZOV,
      POPIS: "TUV",
      SPOTREBA: {
        currYear: {
          yearName: _currYearDate.getFullYear(),
          data: chartDataCurrYear[0].data,
        },
        lastYear: {
          yearName: _lastYearDate.getFullYear(),
          data: chartDataLastYear[0].data,
        },
      },
    },
    {
      ID: 1,
      NAZOV,
      POPIS: "UK",
      SPOTREBA: {
        currYear: {
          yearName: _currYearDate.getFullYear(),
          data: chartDataCurrYear[1].data,
        },
        lastYear: {
          yearName: _lastYearDate.getFullYear(),
          data: chartDataLastYear[1].data,
        },
      },
    },
    {
      ID: 2,
      NAZOV,
      POPIS: "VODA",
      SPOTREBA: {
        currYear: {
          yearName: _currYearDate.getFullYear(),
          data: chartDataCurrYear[2].data,
        },
        lastYear: {
          yearName: _lastYearDate.getFullYear(),
          data: chartDataLastYear[2].data,
        },
      },
    },
  ];
};
const handleChartData = (year, data) => {
  const dataTUV = [...new Array(12).map((x) => 0)];
  const dataUK = [...new Array(12).map((x) => 0)];
  const dataVoda = [...new Array(12).map((x) => 0)];

  data.forEach((d) => {
    const month = new Date(d.D_KONIEC_OBD).getMonth();

    dataTUV[month] = d.SPOTREBA_TUV;
    dataUK[month] = d.SPOTREBA_UK;
    dataVoda[month] = d.SPOTREBA_VODA;
  });

  return [
    {
      name: "TUV - " + year,
      data: dataTUV,
    },
    {
      name: "UK - " + year,
      data: dataUK,
    },
    {
      name: "Voda - " + year,
      data: dataVoda,
    },
  ];
};

// BUILD VARIABLES
const buildSpotreby = (id = "") => {
  return `${urls.Spotreby}/${id}`;
};
const buildFilter = (filter, lastYear = false) => {
  const filters = [
    {
      field: "D_KONIEC_OBD",
      operator: "isnotnull",
    },
  ];

  if (lastYear) {
    filters.push(
      {
        field: "D_KONIEC_OBD",
        operator: "gte",
        value: _lastYearDate,
      },
      {
        field: "D_KONIEC_OBD",
        operator: "lt",
        value: _currYearDate,
      }
    );
  } else {
    filters.push({
      field: "D_KONIEC_OBD",
      operator: "gte",
      value: _currYearDate,
    });
  }

  return {
    logic: "and",
    filters: [...filter.filters, ...filters],
  };
};

// GET DATA
export const getSpotreba = async (NAZOV_OM = "", filter, sort, page) => {
  const url = buildSpotreby();

  try {
    // HANDLE CHART DATA LAST YEAR
    let filterByYear = buildFilter(filter, true);
    let res = await requests.getList(url, filterByYear, sort, page);

    const chartDataLastYear = handleChartData(
      _lastYearDate.getFullYear(),
      res.Data.Items
    );

    // HANDLE CHART DATA CURRENT YEAR
    filterByYear = buildFilter(filter);
    res = await requests.getList(url, filterByYear, sort, page);

    const chartDataCurrYear = handleChartData(
      _currYearDate.getFullYear(),
      res.Data.Items
    );

    // MERGE
    const chartData = [...chartDataLastYear, ...chartDataCurrYear];
    const gridData = handleGridData(
      NAZOV_OM,
      chartDataCurrYear,
      chartDataLastYear
    );

    return { chartData, gridData };
  } catch (error) {
    throw error;
  }
};
